import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import WaitlistEdit         from "./WaitlistEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Waitlist List
 * @returns {React.ReactElement}
 */
function WaitlistList() {
    const { fetch, load } = useList("ticketWaitlist");

    const data = Store.useState("ticketWaitlist");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("ticketWaitlist");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "ticketWaitlistID", elemID, "name");

    return <Main>
        <Header message="TICKET_WAITLISTS_NAME" icon="waitlist">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="TICKET_WAITLISTS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"     message="TICKET_WAITLISTS_SINGULAR" isTitle />
                    <TableHeader field="status"   message="GENERAL_STATUS"            align="center" maxWidth="100" />
                    <TableHeader field="position" message="GENERAL_POSITION"          maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.ticketWaitlistID} elemID={elem.ticketWaitlistID}>
                        <TableCell message={elem.name}       />
                        <TableCell message={elem.statusName} textColor={elem.statusColor} />
                        <TableCell message={elem.position}   />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="TICKET_WAITLISTS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="TICKET_WAITLISTS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <WaitlistEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="TICKET_WAITLISTS_DELETE_TITLE"
            message="TICKET_WAITLISTS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default WaitlistList;
